import axios from '@/mod/axiosMod';

export default {
  /**
   * 获取待签约合作信息
   * @param poiIdList 门店ID列表: [int(ids1), int(ids2), ...]
   * confirmStatus 合同确认状态：0:未确认的合同；1:已确认的合同
   * @returns {*}
   */
  getNotSignedContracts(poiIdList) {
    return axios.post('/shepherd/api/v1/contract/batch-query', {
      poiIdList,
      confirmStatus: 0,
    });
  },
  /** 旧：获取签约合同最新版 */
  getUnSignContract(data) {
    return axios.post('/shepherd/api/v1/contract/batch-query2', data);
  },
  /** 新：获取签约合同最新版 */
  getUnSignContractNew(data) {
    return axios.post('/shepherd/api/v1/contract/batch-query-v3', data);
  },
  /**
   * 确认签约
   * @param poiId 门店ID
   * @returns {*}
   */
  signContract(poiId) {
    return axios.post('/api/v1/contract/sign', {
      poiId,
    });
  },
  /**
   * 批量签约（目前仅用于上单信息确认签约）
   */
  batchSignContract() {
    return axios.post('/apigw/api/kdb/confirm-benefits', { confirmAll: true });
  },
  /**
   * 获取所有合作信息
   * @param poiId 门店ID
   * @param poiStatus 门店的商家入驻状态 1-已签约、2-已开通、3-已解约
   * @param poiSource 门店来源 1-运营平台、2-上单系统
   * @returns {*}
   */
  getSignedContracts(poiId, poiStatus, poiSource = 2) {
    return axios.post('/api/v1/contract/info', {
      poiId,
      poiStatus,
      poiSource,
    });
  },
  getPoiDetail(poiId) {
    return axios.post('/apigw/api/get/contract/list', { poiId });
  },
  /**
   * 账号下已确认的待预览合同列表
   * @param poiId 门店ID
   */
  querySignedContractInUser(poiId) {
    return axios.post('/api/v2/contract/query-signed-contract-pdf', { poiId });
  },
  /**
   * 获取待核销数据列表
   */
  getInvoiceDetails() {
    return axios.get('/api/v1/invoice/detail');
  },
  /**
   * 获取收票地址
   */
  getInvoiceReceiver() {
    return axios.get('/api/v1/invoice/receiver');
  },
  /**
   * 获取合同列表
   */
  getContractDetails(pageNum, pageSize) {
    return axios.post('/apigw/api/get/contract/detail/list', { pageNum, pageSize });
  },
};
